import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {ManagerOnlyGuard} from './guards/manager-only.guard';
import {AuthOnlyGuard} from './guards/auth-only.guard';
import {GuestOnlyGuard} from './guards/guest-only.guard';
import {HomeMultiGuard} from './guards/home-multi-guard.service';
import {HomeClassicGuard} from './guards/home-classic-guard.service';
import {UserInfoResolver} from './resolvers/user-info.resolver';
import {WwwRedirectGuard} from './guards/www-redirect.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
    canActivate: [GuestOnlyGuard, WwwRedirectGuard],
  },
  {
    path: 'static',
    loadChildren: () => import('./modules/static-pages/static-pages.module').then(m => m.StaticPagesModule)
  },
  {
    path: 'ui-kit',
    loadChildren: () => import('./modules/ui-kit/ui-kit.module').then(m => m.UiKitModule)
  },
  {
    path: '',
    resolve: {userInfo: UserInfoResolver},
    children: [
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      {
        path: 'home', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
        canActivate: [AuthOnlyGuard, HomeClassicGuard],
      },
      {
        path: 'home-multi', loadChildren: () => import('./modules/home-multi/home-multi.module').then(m => m.HomeMultiModule),
        canActivate: [AuthOnlyGuard, HomeMultiGuard],
      },
      {
        path: 'home-inspire', loadChildren: () => import('./modules/home-inspire/home-inspire.module').then(m => m.HomeInspireModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'review', loadChildren: () => import('./modules/review/review.module').then(m => m.ReviewModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'calls', loadChildren: () => import('./modules/calls/calls.module').then(m => m.CallsModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'tasks',
        loadChildren: () => import('./modules/tasks/tasks.module').then(m => m.TasksModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'journey',
        loadChildren: () => import('./modules/journey/journey.module').then(m => m.JourneyModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'e-learning',
        loadChildren: () => import('./modules/e-learning/e-learning.module').then(m => m.ELearningModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'skills-checker',
        loadChildren: () => import('./modules/skills-checker/skills-checker.module').then(m => m.SkillsCheckerModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'coaching',
        loadChildren: () => import('./modules/coaching/coaching.module').then(m => m.CoachingModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'resources',
        loadChildren: () => import('./modules/resources/resources.module').then(m => m.ResourcesModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'account',
        loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'social',
        loadChildren: () => import('./modules/social/social.module').then(m => m.SocialModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'quiz',
        loadChildren: () => import('./modules/quiz/quiz.module').then(m => m.QuizModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'simulator',
        loadChildren: () => import('./modules/simulator/simulator.module').then(m => m.SimulatorModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'team',
        loadChildren: () => import('./modules/team/team.module').then(m => m.TeamModule),
        canActivate: [AuthOnlyGuard, ManagerOnlyGuard],
      },
      {
        path: 'coach',
        loadChildren: () => import('./modules/coach/coach.module').then(m => m.CoachModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'videochat',
        loadChildren: () => import('./modules/video-chat/video-chat.module').then(m => m.VideoChatModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'leaderboard',
        loadChildren: () => import('./modules/leaderboard/leaderboard.module').then(m => m.LeaderboardModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'conference',
        loadChildren: () => import('./modules/conference/conference.module').then(m => m.ConferenceModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'test',
        loadChildren: () => import('./modules/test/test.module').then(m => m.TestModule),
        canActivate: [AuthOnlyGuard],
      },
      {
        path: 'game',
        loadChildren: () => import('./modules/game/game.module').then(m => m.GameModule),
      },
    ]
  },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      // enableTracing: true
      // useHash: true
    })

  ],
  exports: [RouterModule],
  providers: [ManagerOnlyGuard, AuthOnlyGuard, GuestOnlyGuard]
})
export class AppRoutingModule {
}
